import axios from "axios";

export default {
  metaInfo: {
    title: "고객혜택",
  },
  data() {
    return {
      benefits: [],
    };
  },
  computed: {
    getTitle() {
      return "우리 회사에는\n어떤 혜택이 필요할까?";
    },
  },
  methods: {
    openLink(link) {
      window.open(link || "https://www.dvercorp.co.kr");
    },
    async getBenefits() {
      // AWS FrontEnd S3, CloudFront
      const { data } = await axios.get(
        "https://d8te26mvez0yp.cloudfront.net/benefits.json"
      );
      this.benefits = data.benefits;
    },
  },
  async created() {
    await this.getBenefits();
  },
};
